// Central registry of generated brand assets.
const BASE = "https://static.prod-images.emergentagent.com/jobs/03e2ad94-c9fd-49e4-9d5f-e5a8b6ab5ecd/images";

export const ASSETS = {
  hammerBadge: `${BASE}/911c087bb44affd38b404b372e257c964bd67dab06dad1db928607c44d8b0168.jpeg`,
  starterBadge: `${BASE}/7fa5786db1271ae6d4e8b87e2f0e320e794055b362c698e3cfb92043669c0df0.jpeg`,
  heroCenter: `${BASE}/6a56083889f2ca30f411d06436107d1a65fa8dad5c736e0259c239658fedcae1.jpeg`,
  ebookCover: "https://customer-assets-jt897jd0.emergentagent.net/job_sportsbook-lab/artifacts/a591437dd83794cb_file_000000003f8c820c96838aab1f55b8a4.png",
};

// Black hammer smashing each sport object — used for the "Choose Your Sport" row
// and sport-page headers.
export const SMASH_IMAGES = {
  football: `${BASE}/e3231bff975cf34a32fb4a817ed03fb233cd0f017137fdc7c77d6656f07038f8.jpeg`,
  basketball: `${BASE}/f9ffec6ab4226b1627ac1351ed3edba5984077d39f9dec5d7eb6d553cfc33d2b.jpeg`,
  baseball: `${BASE}/46baa57ab14dbdd8f8271a88a8ee7cce295415ca5830d0390074ce94a422c32b.jpeg`,
  soccer: `${BASE}/982c6575ea8e18b37ab0af89cc4126c8dfc92c80681532e1bf4d260df9b2fcb3.jpeg`,
  hockey: `${BASE}/5e655a9372fae7ad6f777d2add4fa69207801f661264d8dc92a07473e8fdd6f2.jpeg`,
  boxing: `${BASE}/b24e85c22e8642817f948d75f1cc546c0bcc38844dead19d07b78b4f21c5c144.jpeg`,
  mma: `${BASE}/51d63c7b88c323eaa7bebd316fe4c6bd16143de7b3317ae8a1b21e09234da0a3.jpeg`,
};
